import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 80px 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: ${props => props.theme.colors.primary};
  text-align: center;
  margin-bottom: 2rem;
`;

const Content = styled.div`
  font-size: 1.1rem;
  line-height: 1.8;
  color: ${props => props.theme.colors.text};
`;

const AdminCoursesPage = () => {
  return (
    <Container>
      <Title>Manage Courses</Title>
      <Content>
        <p>Admin interface for managing courses and qualifications.</p>
      </Content>
    </Container>
  );
};

export default AdminCoursesPage; 